import { Plan } from '../../../types/plan';
import { formatAmountUI } from '../../../utils/price/price.utils';
import {
  ProductContainer,
  ProductLabel,
  ProductLabelWeekly,
  ProductMostPopularBadge,
  ProductPriceBig,
  ProductPriceContainer,
  ProductPriceLeft,
  ProductPriceRight,
  ProductPriceRightBig,
  ProductPriceRightSmall,
  ProductPriceSmall,
  ProductTitle,
  ProductTitleRow,
} from './ProductV3.style';

interface ProductV1Props {
  product: Plan;
  chosenPlanPosition?: string | null;
  onClick: () => void;
}

export const ProductV3 = ({ product, onClick, chosenPlanPosition }: ProductV1Props) => {
  const { amount, metadata } = product;
  const isPicked = metadata.position === chosenPlanPosition;
  const totalPriceUI = formatAmountUI(amount);

  return (
    <ProductContainer onClick={onClick} isPicked={isPicked}>
      <ProductTitleRow>
        <ProductTitle>{metadata.planTitle}</ProductTitle>
        {metadata.isBestValue && <ProductMostPopularBadge>Best value</ProductMostPopularBadge>}
      </ProductTitleRow>
      <ProductLabel withPaddingBottom={!metadata.isBestValue}>
        {metadata.description}
        <ProductLabelWeekly> / week</ProductLabelWeekly>
      </ProductLabel>
      <ProductPriceContainer>
        <ProductPriceLeft>
          <ProductPriceBig>${metadata.weeklyPrice}</ProductPriceBig>
          <ProductPriceSmall>/ week</ProductPriceSmall>
        </ProductPriceLeft>
        <ProductPriceRight>
          <ProductPriceRightBig>Total ${totalPriceUI}</ProductPriceRightBig>
          <ProductPriceRightSmall>{metadata.billingPeriodLabel}</ProductPriceRightSmall>
        </ProductPriceRight>
      </ProductPriceContainer>
    </ProductContainer>
  );
};
